import { h } from 'preact';
import ArrowRightIcon from 'utils/icon/icon-arrow-right.svg';

const MenuListItem = ({ image, text, url, caption, largeImages }) => {
  if (image) {
    if (largeImages) {
      return (
        <a
          href={url}
          className="block mb-8 last:mb-0 relative text-white lg:max-w-[282px]"
        >
          <img src={image} alt={text} className="w-full" />
          <div className="display-4 absolute p-8 md:py-14 tablet:p-8 ml:py-16 bottom-0 left-0  lc:animated-arrow-link">
            <div className="lc:inline ml:border-b ml:border-current ml:hover:border-transparent">
              {text}
            </div>
            <ArrowRightIcon className="inline-block ml-4 h-10 w-auto ml:hidden" />
          </div>
        </a>
      );
    }

    return (
      <a
        href={url}
        className="mb-16 pb-16 tablet:mb-8 tablet:pb-8 last:mb-0  gap-8 flex items-center border-b border-grey-300"
      >
        <img
          src={image}
          alt={text}
          className="w-36 h-48 object-contain lc:rounded-4"
        />
        <div className="body-1 tablet:body-2 hover:underline">{text}</div>
      </a>
    );
  }

  return (
    <a
      href={url}
      className="ml-24 tablet:ml-0 block mb-24 tablet:mb-16 last:mb-0"
    >
      <div className="body-1 tablet:body-2 hover:underline">{text}</div>
      {caption && (
        <div className="body-3 text-subdued hover:underline">{caption}</div>
      )}
    </a>
  );
};

export default MenuListItem;
